// Filtro de datos sensibles para Sentry.
//
// Frameweb recibe la credencial del cliente en la URL (`/#/v2/booking/...?apiKey=<uuid>`), y
// Sentry envía la URL en `request.url`, en los breadcrumbs de navegación, en el Referer y en los
// spans de tracing. Sin este filtro, cada evento guarda en Sentry SaaS la apiKey del cliente.
//
// Se recorre el evento ENTERO en lugar de un campo concreto: la clave aparece en sitios distintos
// según el tipo de evento (error, transacción, breadcrumb) y la lista cambia con el SDK.

export const SENSITIVE_QUERY_PARAMS = ["apiKey", "token"];
export const FILTERED = "[Filtered]";

const PARAM_PATTERN = new RegExp(
  "([?&#;]\\s*(?:" + SENSITIVE_QUERY_PARAMS.join("|") + ")\\s*=)([^&#\\s]*)",
  "gi"
);

/** Sustituye el valor de los parámetros sensibles dentro de un string (URL o fragmento). */
export function scrubString(value) {
  if (typeof value !== "string" || value.indexOf("=") === -1) return value;
  return value.replace(PARAM_PATTERN, "$1" + FILTERED);
}

/** Recorre recursivamente objetos y arrays devolviendo una copia con los strings filtrados. */
export function scrubDeep(value, seen = new WeakSet()) {
  if (typeof value === "string") return scrubString(value);
  if (!value || typeof value !== "object") return value;
  if (seen.has(value)) return value; // ciclos: se deja tal cual
  seen.add(value);
  if (Array.isArray(value)) return value.map((item) => scrubDeep(item, seen));
  const out = {};
  Object.keys(value).forEach((key) => {
    out[key] = scrubDeep(value[key], seen);
  });
  return out;
}

/** Hooks para Sentry.init. `beforeSend*` y `beforeBreadcrumb` reciben el objeto y devuelven el filtrado. */
export const sentryScrubHooks = {
  beforeSend: (event) => scrubDeep(event),
  beforeSendTransaction: (event) => scrubDeep(event),
  beforeBreadcrumb: (breadcrumb) => scrubDeep(breadcrumb),
};
